import React from "react";
import { motion } from "framer-motion";
import './Client.css';

const TESTIMONIALS = [
  {
    name: "Curtis Hackett",
   
    content: "Josh and Joaquin came to my house to handle our lawn, and it was done amazingly. They even threw in some edging work, and it all came out to a very good price. Will be utilizing them again",
    rating: 5
  },
  {
    name: "Joo Young Han",
   
    content: "Thanks to Joaquin and his team, my back lawn is looking great again. I had a massive detaching and reseeding that needed to be done. My package included detaching, topsoil, seeding plus fertilizers. Joaquin was quick to respond and made sure that my lawn was taken care of.",
    rating: 5
  },
  {
    name: "Allison Thomas",
  
    content: "Josh and Joaquin have done an exceptional job with our property. We wanted a reliable landscape team that also was at the right price. I appreciate that they communicate what they are doing while on the property, for example if they need to spray weed killer they told us to make sure our dogs didn't go outside near that area.",
    rating: 5
  }
];

const TestimonialCard = ({ name, role, content, rating }) => {
  const stars = Array(5).fill(0).map((_, i) => (
    <svg 
      key={i} 
      className={`testimonial-star ${i < rating ? "filled" : ""}`}
      width="20" 
      height="20" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill={i < rating ? "currentColor" : "none"}
      />
    </svg>
  ));
  
  return (
    <motion.div 
      className="testimonial-card"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      whileHover={{ y: -8 }}
      transition={{ duration: 0.4, type: "spring", stiffness: 200 }}
    >
      <div className="testimonial-rating">{stars}</div>
      <p className="testimonial-content">"{content}"</p>
      <div className="testimonial-author">
        <h4 className="testimonial-name">{name}</h4>
        <p className="testimonial-role">{role}</p>
      </div>
      <div className="testimonial-accent"></div>
    </motion.div>
  );
};

const ClientTestimonials = () => {
  return (
    <section className="client-testimonials" id="testimonials">
      <div className="testimonials-pattern"></div>
      <div className="client-container">
        <div className="testimonials-header">
          <motion.p 
            className="section-subtitle"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            Client Experiences
          </motion.p>
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Voices of <span>Satisfaction</span>
          </motion.h2>
          <motion.p 
            className="section-description"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            Discover why homeowners and businesses trust Primed Landscaping for their outdoor transformations.
          </motion.p>
        </div>
        
        <div className="testimonials-grid">
          {TESTIMONIALS.map((testimonial, index) => (
            <TestimonialCard 
              key={index}
              {...testimonial}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientTestimonials;